module.exports = __webpack_public_path__ + "static/media/INZ1025.67ebec74.pdf";